import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { pushCustomEvent } from '../../trackers/utils';
import './customerSupportMenu.scss';
export default function CustomerSupportMenu(_ref) {
  var isOpen = _ref.isOpen,
      isOpenByKeyboard = _ref.isOpenByKeyboard,
      locationStyle = _ref.locationStyle,
      onBlur = _ref.onBlur,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      onChatNowClick = _ref.onChatNowClick;
  var focusElemRef = useRef();
  useEffect(function () {
    if (isOpen && isOpenByKeyboard && focusElemRef.current) {
      setTimeout(function () {
        return focusElemRef.current.focus();
      }, 10);
    }
  }, [isOpen, isOpenByKeyboard, focusElemRef.current]);
  useEffect(function () {
    if (isOpen) {
      pushCustomEvent('modal_display', 'custom_engage', 'customer_support');
    }
  }, [isOpen]);

  function handleChatNowClick() {
    var _window, _window$adaEmbed;

    pushCustomEvent('chat_now_click', 'custom_engage', 'customer_support'); // Ada chat bot is loaded via script tag in theme.liquid
    // eslint-disable-next-line no-unused-expressions

    (_window = window) === null || _window === void 0 ? void 0 : (_window$adaEmbed = _window.adaEmbed) === null || _window$adaEmbed === void 0 ? void 0 : _window$adaEmbed.toggle();
    onChatNowClick();
  }

  function handleHelpCenterClick() {
    var _window2, _window2$bt, _window2$bt$settings;

    pushCustomEvent('help_center_click', 'custom_engage', 'customer_support');
    window.location = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$bt = _window2.bt) === null || _window2$bt === void 0 ? void 0 : (_window2$bt$settings = _window2$bt.settings) === null || _window2$bt$settings === void 0 ? void 0 : _window2$bt$settings.helpCenterUrl;
  }

  function handleBlurEvent(evt) {
    // when focus leaves the dropdown menu
    if (!evt.currentTarget.contains(evt.relatedTarget)) {
      onBlur(evt);
    }
  }
  /* eslint-disable quotes */


  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "SiteNavLabel-customer-support",
    className: "cs-menu ".concat(isOpen ? 'cs-menu--active' : ''),
    style: locationStyle,
    "aria-expanded": isOpen,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onBlur: handleBlurEvent
  }, /*#__PURE__*/React.createElement("p", {
    className: "h1 help-text"
  }, "HOW CAN WE HELP YOU?"), /*#__PURE__*/React.createElement("div", {
    className: "cs-menu-chat-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cs-menu-image-container"
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://www.biotrust.com/cdn/shop/t/41/assets/chat-agent.png",
    alt: "24/7 Chat"
  })), /*#__PURE__*/React.createElement("div", {
    className: "cs-menu-support-content-container"
  }, /*#__PURE__*/React.createElement("h3", null, "24/7 CHAT"), /*#__PURE__*/React.createElement("p", null, "Get help now from Aidan, your BioTRUST product expert"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-chat-now",
    onClick: handleChatNowClick,
    ref: focusElemRef
  }, "CHAT NOW"))), /*#__PURE__*/React.createElement("div", {
    className: "cs-menu-help-center-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cs-menu-image-container"
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://www.biotrust.com/cdn/shop/t/41/assets/question-mark.png",
    alt: "Questions"
  })), /*#__PURE__*/React.createElement("div", {
    className: "cs-menu-support-content-container"
  }, /*#__PURE__*/React.createElement("h3", null, "Questions?"), /*#__PURE__*/React.createElement("p", null, "Get answers by visiting the customer help center"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-help-center",
    onClick: handleHelpCenterClick
  }, "HELP CENTER")))));
}
CustomerSupportMenu.propTypes = {
  isOpen: PropTypes.bool,
  isOpenByKeyboard: PropTypes.bool,
  locationStyle: PropTypes.object,
  onBlur: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func.isRequired,
  onMouseLeave: PropTypes.func.isRequired,
  onChatNowClick: PropTypes.func.isRequired
};